import React from "react";
import { useTranslation } from "react-i18next";
import { ComingSoonScreen } from "./ComingSoonScreen";

/** Sliders icon for the Settings placeholder. */
const SlidersIcon: React.FC = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6" />
  </svg>
);

/** Settings placeholder (FE-7): title + centered coming-soon card. */
export const SettingsScreen: React.FC = () => {
  const { t } = useTranslation();
  return (
    <ComingSoonScreen
      title={t("placeholders.settings.title")}
      subtitle={t("placeholders.settings.subtitle")}
      icon={<SlidersIcon />}
      cardTitle={t("placeholders.settings.cardTitle")}
      cardBody={t("placeholders.settings.cardBody")}
    />
  );
};
